// src/components/MobileNav.js
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './MobileNav.css'; // We'll need this CSS file for proper media queries

const routeSettings = {
  '/how-it-works': { color: '#FA8609' },
  '/faqs': { color: '#14B1E7' },
  '/login': { color: '#FFCB05' },
  '/profile': { color: '#FFCB05' },
};

const MobileNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  // Find which route we're currently on
  const currentPath = Object.keys(routeSettings).find(route => 
    location.pathname.startsWith(route)
  );

  const navItems = [
    { label: 'How it Works', path: '/how-it-works' },
    { label: 'FAQs', path: '/faqs' },
    { label: 'Profile', path: '/login' }
  ];

  return (
    <div className="mobile-nav">
      {navItems.map((item, index) => {
        const isActive = currentPath === item.path;
        const activeColor = isActive ? routeSettings[item.path]?.color : '#FFF';
        
        return (
          <button
            key={index}
            onClick={() => navigate(item.path)}
            className="mobile-nav-item"
            style={{
              color: activeColor
            }}
          >
            {item.label}
          </button>
        );
      })}
    </div>
  );
};

export default MobileNav;